import './styles.css'

const Rope = () => (
  <div className='rope'>
    <span className='vertical' />
    <span className='round' />
  </div>
)

export default Rope